import { routerFrom } from "router";

export const routes = [
  {
    acl: [],
    label: "Dashboard Page",
    name: "dashboard",
    path: "/app/dashboard",
    testName: "dashboard",
  },
  {
    acl: [],
    label: "Dashboard Page Recommended Jobs",
    name: "dashboard.recommended",
    path: "/app/dashboard?tab=recommended",
    testName: "dashboard-recommended",
  },
  {
    acl: [],
    label: "Dashboard Page Saved Jobs",
    name: "dashboard.saved",
    path: "/app/dashboard?tab=saved",
    testName: "dashboard-saved",
  },
];

export const router = routerFrom(routes);
